import { ReactNode, useMemo } from "react";
import styles from "./FieldHeader.module.css"
import Tooltip from "@view/common/Components/Tooltip";

export interface ITooltipProps {
  label?: string;
  supportText?: string;
  id?: string;
  error?: boolean;
  tooltip?: string;
  requiredIndicator?: ReactNode;
  className?: string;
  labelClassName?: string;
  children?: ReactNode;
}

const FieldHeader = ({
  label,
  supportText,
  id,
  error,
  className,
  requiredIndicator,
  tooltip,
  children
}: ITooltipProps) => {

  const _labelClassName = useMemo(() => (
    [
      styles.root,
      error ? styles.error : undefined,
      className,
    ].filter(x => x !== undefined).join(" ")
  ), [className, error]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.labelContainer}>
        {label && (
          <div>
            <label
              className={_labelClassName}
              htmlFor={id}
              dangerouslySetInnerHTML={{
                __html: label ?? "",
              }}
            >
            </label>
            {
              requiredIndicator === true ?
                <span className={styles.requiredIndicator}> *</span> :
                requiredIndicator
            }
          </div>
        )}
        {
          supportText && (
            <span
              className={styles.supportText}
              dangerouslySetInnerHTML={{
                __html: supportText ?? "",
              }}
            >
            </span>
          )
        }
      </div>
      {children}
      {tooltip && (
        <Tooltip text={tooltip} />
      )}
    </div>
  );
};

export default FieldHeader;
